<template>
  <InternalLoading
    v-if="!uiBlock"
    :type="type"
    :size="size"
    :model-value="modelValue"
    :color="color"
    :ui-block="uiBlock"
    :aria-hidden="ariaHidden"
  >
    <slot />
  </InternalLoading>
  <SbBlockUI v-else>
    <InternalLoading
      :type="type"
      :size="size"
      :model-value="modelValue"
      :color="color"
      :ui-block="uiBlock"
      :aria-hidden="ariaHidden"
    >
      <slot />
    </InternalLoading>
  </SbBlockUI>
</template>

<script lang="ts" setup>
import SbBlockUI from '../BlockUI'
import InternalLoading from './components/InternalLoading.vue'
import type { SbLoadingProps } from './types'

defineProps<SbLoadingProps>()
</script>

<style lang="scss">
@import './loading';
</style>
